/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

export default [
  {
    width: 180,
    tip: '请输入付款人',
    label: '付款人',
    key: 'payName',
    id: 'payName',
    slot: 'input'
  },
  {
    width: 180,
    tip: '请输入流水号',
    label: '流水号',
    key: 'tradeNo',
    id: 'tradeNo',
    slot: 'input'
  },
  {
    width: 180,
    id: 'monthrange',
    tip: '请选择交易日期',
    label: '交易日期',
    required: false,
    slot: 'monthrange',
    format: 'yyyy-MM',
    rangeValue: [],
    key: ['startDt', 'endDt']
  }
];
